import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import Invoice from "../components/Invoice";

export default function PaymentResult() {
  const { t } = useApp();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("verifying");
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    const id = params.get("id");
    const bookingId = params.get("booking_id");
    if (!id || !bookingId) { setState("failed"); return; }
    api.post("/payments/claim", { payment_id: id, booking_id: bookingId })
      .then((r) => { setBooking(r.data.booking); setState("success"); })
      .catch(() => setState("failed"));
  }, [params]);

  return (
    <div className="pt-28 sm:pt-32 pb-8">
      <div className="px-4 sm:px-8 lg:px-16 max-w-2xl mx-auto text-center">
        {state === "verifying" && (
          <div className="py-20">
            <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto" />
            <p className="mt-4 text-lg text-muted-foreground">{t.common.loading}</p>
          </div>
        )}
        {state === "failed" && (
          <div className="py-16">
            <XCircle className="h-16 w-16 text-destructive mx-auto" />
            <h1 className="mt-4 text-2xl font-bold">{t.common.error}</h1>
            <Button onClick={() => nav("/book")} className="mt-6 rounded-full">{t.booking.title}</Button>
          </div>
        )}
        {state === "success" && (
          <div>
            <CheckCircle2 className="h-16 w-16 text-emerald-500 mx-auto" />
            <h1 className="mt-4 text-3xl font-bold text-foreground">{t.booking.successTitle}</h1>
            <p className="text-muted-foreground mt-2">{t.booking.successSub}</p>
            <div className="mt-8 text-start"><Invoice booking={booking} /></div>
          </div>
        )}
      </div>
    </div>
  );
}
